import { Link } from "react-router-dom";
import { Building2, Factory, Trees, Cpu, ArrowRight } from "lucide-react";

const worlds = [
  {
    icon: Building2,
    label: "Inside the Facility",
    items: ["Cleaning", "Delivery", "Customer Service", "Facility Operations"],
    to: "/robots",
  },
  {
    icon: Factory,
    label: "Factory & Warehouse",
    items: ["Material Transport", "Industrial Robotics", "Humanoids", "Inspection"],
    to: "/robots/humanoid",
  },
  {
    icon: Trees,
    label: "Outside the Facility",
    items: ["Autonomous Mowing", "Grounds Maintenance", "Turf", "Infrastructure"],
    to: "/robots/landscape",
  },
  {
    icon: Cpu,
    label: "Digital Operations",
    items: ["AI Employees", "Voice AI", "CRM", "Workflow Automation"],
    to: "/ai-workforce",
  },
];

const ThreeWorldsSection = () => (
  <section aria-labelledby="three-worlds-heading" className="my-12 md:my-20">
    <div className="text-center max-w-3xl mx-auto mb-8 md:mb-12">
      <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-primary mb-3">
        One automation partner
      </p>
      <h2
        id="three-worlds-heading"
        className="font-orbitron font-bold text-[clamp(24px,4vw,44px)] leading-[1.1]"
      >
        Across Your Entire Operation
      </h2>
      <p className="mt-4 text-muted-foreground text-base md:text-lg">
        Neil AI connects physical and digital automation into a single operating strategy —
        indoors, in production environments, across your grounds, and inside your workflows.
      </p>
    </div>

    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {worlds.map(({ icon: Icon, label, items, to }) => (
        <Link
          key={label}
          to={to}
          className="group rounded-2xl border border-[hsl(var(--line))] bg-white/[0.03] p-6 transition-colors hover:border-primary/50 hover:bg-primary/5"
        >
          <Icon className="h-7 w-7 text-primary mb-4" aria-hidden="true" />
          <h3 className="font-orbitron text-base md:text-lg font-bold uppercase tracking-wide mb-3">
            {label}
          </h3>
          <ul className="space-y-1.5 text-sm text-muted-foreground">
            {items.map((i) => (
              <li key={i}>{i}</li>
            ))}
          </ul>
          <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-primary">
            Explore <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </span>
        </Link>
      ))}
    </div>

    <p className="mt-8 text-center font-orbitron text-sm md:text-lg font-bold uppercase tracking-[0.12em] text-muted-foreground">
      Physical Automation <span className="text-primary">+</span> Digital Automation{" "}
      <span className="text-primary">=</span>{" "}
      <span className="text-foreground">Autonomous Workforce</span>
    </p>
  </section>
);

export default ThreeWorldsSection;
